export const headerConfig = {
  "nav_links": [
    { "href": "/", "label": "خانه" },
    { "href": "/blog", "label": "وبلاگ" },
    // { "href": "/plans", "label": "مقایسه" },
    { "href": "/models", "label": "مدل ها" },
    { "href": "/faq/", "label": "پرسش های متداول" },
    { "href": "/contact-us/", "label": "تماس با ما" },
    { "href": "/about-us/", "label": "درباره ما" }
  ]
}

export type HeaderConfig = typeof headerConfig
